import { createEvent, SpecificEvents } from "./AnalyticsEvents";
import { HTTPClientInterface, HTTPRequest } from "@core/HTTPClientInterface";
import { buildURL, SystemURL } from "@services/URLCatalog";
import { QontactUser } from "@models/QontactUser";
import { isMobile } from "react-device-detect";
import { Logger } from "@utils/Logger";


export class Analytics {
    private httpClient: HTTPClientInterface
    private user?: QontactUser
    private selectedOrganizationID?: string

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient
    }

    setUser(user: QontactUser) {
        this.user = user
    }

    setSelectedOrganizationID(organizationID: string) {
        this.selectedOrganizationID = organizationID
    }

    async track<T extends SpecificEvents>(event: T): Promise<void> {
        let appEvent = createEvent(
            {
                organizationID: this.selectedOrganizationID,
                userID: this.user?.id,
                source: isMobile ? 'demo-web-mobile' : 'demo-web'
            },
            event
        )
        
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Analytics.postEvent, {})
        request.method = "POST";
        request.body = appEvent;
        Logger.log("Analytics", "tracked "+event.eventType)
        try {
            await this.httpClient.execute(request);
        } catch (error) {
            Logger.logError("Analytics", error)
        }
    }
}